module.exports = __webpack_public_path__ + "static/8-0f74042a231b4c58fe4cdbfbf73e4c6e.png";